<script lang="ts" setup>

	import {getProductDetailUrl} from '@/api/api';
	import OrderInput from '@/components/orderinput/OrderInput.vue';
	import {useRegionStore} from '@/store/region.store';
	import type {Substitute} from 'dummen-shared';
	import {computed} from 'vue';

	const props = defineProps<{
		week: number;
		year: number;
		substitute: Substitute;
	}>();

	const regionStore = useRegionStore();

	const selectedRegion = computed(() => regionStore.getSelectedRegionUrlName());

	const getDetailUrl = computed(() => {
		const selectedRegion = useRegionStore().getSelectedRegionUrlName();
		const {urlFriendlyId, urlFriendlyName, urlFriendlyProductgroup} = props.substitute;

		return getProductDetailUrl(selectedRegion, urlFriendlyId, urlFriendlyName, urlFriendlyProductgroup);
	});

</script>

<template>
	<div class="substitute-variety--wrapper">
		<div class="substitute-variety--info">
			<a v-if="substitute.image" :href="getDetailUrl" target="_blank">
				<img :src="substitute.image"
				     alt="/assets/images/build/fallback-product-image.jpg"
				     data-pagespeed-no-transform
				     height="180"
				     width="180" />
			</a>

			<a v-else :href="getDetailUrl" target="_blank">
				<img alt="fallback-image"
				     data-pagespeed-no-transform
				     height="180"
				     src="/assets/images/build/fallback-product-image.jpg"
				     width="180" />
			</a>
		</div>

		<div class="substitute-variety--title">
			<a :href="getDetailUrl" target="_blank">{{ substitute.name }}</a>
		</div>

		<div class="substitute-variety--order">
			<OrderInput :available="substitute.availability"
			            :product="substitute"
			            :region="selectedRegion"
			            :week="week"
			            :year="year" />
		</div>
	</div>
</template>
